/** Display mapping for report statuses — the only place raw enums become UI copy.
 *  Polling behavior is owned by LIVE_STATUSES in liveStatus.ts, not here. */
export interface StatusMeta {
  label: string
  dotClass: string
}

const STATUS_META: Record<string, StatusMeta> = {
  pending: { label: 'Building…', dotClass: 'animate-pulse bg-amber-500' },
  tables_ready: { label: 'Ready', dotClass: 'animate-pulse bg-[var(--report-accent)]' },
  writing: { label: 'Writing…', dotClass: 'animate-pulse bg-[var(--report-accent)]' },
  complete: { label: 'Complete', dotClass: 'bg-muted-foreground/40' },
  tables_failed: { label: 'Build failed', dotClass: 'bg-red-500' },
}

export function statusMeta(status: string): StatusMeta {
  return STATUS_META[status] ?? { label: status, dotClass: 'bg-muted-foreground/40' }
}
